import type { SessionKeyData } from '@polaris/core/models'
import { apiClient } from '../client'

export interface MpcLoginRequest {
  username: string
  email: string
  sessionKeyData: SessionKeyData
}

interface MpcLoginResponse {
  access_token: string
}

/**
 * Shared helper for MPC login via /auth/login/mpc.
 * Used by both Google and Apple MPC flows to avoid duplicating the
 * auth/login/mpc wiring per provider.
 */
export function mpcLogin(payload: MpcLoginRequest): Promise<MpcLoginResponse> {
  return apiClient
    .post('auth/login/mpc', {
      json: payload,
    })
    .json<MpcLoginResponse>()
}
